import React, { FunctionComponent, useState, useEffect } from "react";
import { useFormik } from "formik";
import { TextField, Grid, Typography, Paper, Button } from "@material-ui/core";
import * as Yup from "yup";
import { useResyncConfStyles } from "../useResyncConfStyles";
import { useStore } from "../../../store";
import { SnackBar } from "../../SnackBar";
import { Select } from "../../Select";
import { api } from "../../../api";
interface ResyncConfTablesProps {
  serviceList: any;
}
export const ResyncConfTables: FunctionComponent<ResyncConfTablesProps> = ({
  serviceList,
}) => {
  const classes = useResyncConfStyles();

  const [snackbarColor, setSnackbarColor] = useState<string>("#d50000");
  const [resyncStatus, setResyncStatus] = useState<string>("");
  const [service_list, setServiceList] = useState<Array<object>>([]);
  const [hours_list, setHoursList] = useState<Array<object>>([]);
  const [minsSecs_list, setminsSecsList] = useState<Array<object>>([]);
  const [tables_list, setTablesList] = useState<Array<object>>([]);
  const [terminalList, setTerminalsList] = useState<Array<object>>([]);
  const [isAllTerminalsChecked, SetIsAllTerminalsChecked] = useState<boolean>(
    false
  );
  const [terminalsFlag, SetTerminalsFlag] = useState<boolean>(false);
  const [terminals, { getTerminals }] = useStore("terminals");
  useEffect(() => {
    getServices(serviceList);
    loadHoursList();
    loadMinutesSecondsLists();
  }, []);
  const validationSchema = Yup.object({
    service: Yup.string().required("Required"),
    table: Yup.string().required("Required"),
  });
  const loadHoursList = () => {
    const hours: { value: number; label: string }[] = [];
    for (let i = 0; i <= 24; i++) {
      hours.push({ value: i, label: i.toString() });
    }
    setHoursList(hours);

    return hours;
  };
  const loadMinutesSecondsLists = () => {
    const mins: { value: number; label: string }[] = [];
    for (let i = 0; i <= 60; i++) {
      mins.push({ value: i, label: i.toString() });
    }
    setminsSecsList(mins);
    return mins;
  };

  const getServices = (serviceList: any) => {
    const servicesToLoad =
      serviceList &&
      serviceList.map((item: { [key: string]: any }) => ({
        value: item.service_name,
        label: item.display_name,
      }));
    setServiceList(servicesToLoad);
    return servicesToLoad;
  };

  const getTables = async (servicename: string) => {
    try {
      const result: any = await api.get(`services/${servicename}/tables`);

      if (result !== undefined) {
        setSnackbarColor("green");

        const values: { value: string; label: string }[] =
          result &&
          result.map((item: { [key: number]: any }) => ({
            value: item,
            label: item,
          }));
        setTablesList(values);
        return values;
      }
    } catch (error) {
      setSnackbarColor("red");
    }
  };
  const submitForm = async (values: any) => {
    const terminalArray =
      values.terminals && values.terminals.map((i: any) => i.value);

    const payload = {
      service: values.service,
      table: values.table,
      terminals: terminalArray,
      isAllTerminalsChecked: isAllTerminalsChecked,
      time: {
        hours: values.hours,
        minutes: values.minutes,
        seconds: values.seconds,
        days: values.days,
      },
    };
    console.log("Inside submitform:payload", payload);
    try {
      const result = await api.patch(`services/sync/update`, {}, payload);
      console.log("Inside submitform:api result", result);
      setSnackbarColor("green");
      setResyncStatus("Successfully resynced configuration tables.. ");
      return true;
    } catch (error: any) {
      setSnackbarColor("red");
      setResyncStatus(error?.message);
      return false;
    }
  };
  const getTerminalsList = (service: string) => {
    const terminalList =
      terminals &&
      terminals.map((item: { [key: string]: any }) => ({
        value: item.id,
        label: item.name,
      }));
    terminalList.unshift({ value: 0, label: "Select All" });
    setTerminalsList(terminalList);
  };
  const onCloseSnackbar = () => {
    setResyncStatus("");
  };

  const formik = useFormik({
    initialValues: {
      service: "",
      table: "",
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
      terminals: "",
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      console.log("Inside on Submit", values);
      const status = await submitForm(values);
      console.log("Inside on Submit,status", status);
      if (status) {
        resetForm();
      }
    },
  });

  const {
    touched,
    errors,
    handleChange,
    setFieldValue,
    values,
    resetForm,
    handleSubmit,
  } = formik;

  return (
    <div>
      <SnackBar
        status={resyncStatus}
        onCloseError={onCloseSnackbar}
        color={snackbarColor}
      />
      <Paper style={{ minHeight: "25em", minWidth: "50%" }}>
        <Grid item>
          <Grid container direction="row">
            <Grid item xs>
              <Grid container spacing={5} className={classes.fieldSpace}>
                <Grid item xs={4}>
                  <Grid container direction="column">
                    <Typography
                      style={{ textAlign: "left" }}
                      className={classes.fieldLabelStyles}
                    >
                      Service
                    </Typography>
                    <Select
                      style={{
                        height: "2em",
                      }}
                      onChange={(e: any) => {
                        setFieldValue("service", e.value);
                        setFieldValue("table", null);
                        getTables(e.value);
                        if (
                          e.value === "pos-store" ||
                          e.value === "store-pos"
                        ) {
                          getTerminalsList(e.value);
                          SetTerminalsFlag(true);
                          getTerminalsList(e.value);
                        } else SetTerminalsFlag(false);
                        setFieldValue("service", e.value);
                      }}
                      options={service_list}
                      value={
                        values.service
                          ? service_list.find(
                              (e: any) => e.value === values.service
                            )
                          : null
                      }
                    />
                    {errors.service && touched.service ? (
                      <div style={{ color: "red" }}>{errors.service}</div>
                    ) : null}
                  </Grid>
                </Grid>
                <Grid item xs={4}>
                  <Grid container direction="column">
                    <Typography
                      style={{ textAlign: "left" }}
                      className={classes.fieldLabelStyles}
                    >
                      Tables
                    </Typography>
                    <Select
                      style={{ height: "2em" }}
                      onChange={(value: any) => {
                        setFieldValue("table", value.label);
                      }}
                      options={tables_list}
                      value={
                        values.table
                          ? tables_list.find(
                              (e: any) => e.value === values.table
                            )
                          : null
                      }
                    />
                    {errors.table && touched.table ? (
                      <div style={{ color: "red" }}>{errors.table}</div>
                    ) : null}
                  </Grid>
                </Grid>
                {terminalsFlag ? (
                  <Grid item xs={4}>
                    <Grid container direction="column">
                      <Typography className={classes.fieldLabelStyles}>
                        Terminals
                      </Typography>

                      <Select
                        isMulti={true}
                        style={{ minHeight: "2em" }}
                        onChange={(e: any) => {
                          if (e.find((t: any) => t.value === 0)) {
                            SetIsAllTerminalsChecked(true);
                            const filteredTerminals = terminalList.filter(
                              (item: any) => item.value !== 0
                            );
                            setFieldValue("terminals", filteredTerminals);
                          } else {
                            setFieldValue("terminals", e);

                            SetIsAllTerminalsChecked(false);
                          }
                        }}
                        options={terminalList}
                        value={terminalList.filter((e: any) =>
                          values.terminals.includes(e)
                        )}
                      ></Select>
                    </Grid>
                  </Grid>
                ) : null}
              </Grid>
            </Grid>
          </Grid>
          <Grid container direction="row">
            <Grid item xs>
              <Grid container spacing={5} className={classes.fieldSpace}>
                <Grid item xs={3}>
                  <Grid container direction="column">
                    <Typography className={classes.fieldLabelStyles}>
                      Days
                    </Typography>
                    <TextField
                      variant="outlined"
                      inputProps={{ maxLength: 40 }}
                      name="days"
                      type="number"
                      value={values.days}
                      onChange={(e) => {
                        handleChange(e);
                      }}
                      fullWidth={true}
                    />
                  </Grid>
                </Grid>
                <Grid item xs={3}>
                  <Grid container direction="column">
                    <Typography
                      style={{ textAlign: "left" }}
                      className={classes.fieldLabelStyles}
                    >
                      Hours
                    </Typography>
                    <Select
                      style={{ height: "2em" }}
                      onChange={(value: any) => {
                        setFieldValue("hours", value.value);
                      }}
                      options={hours_list}
                      value={hours_list.find(
                        (e: any) => e.value === values.hours
                      )}
                    ></Select>
                  </Grid>
                </Grid>
                <Grid item xs={3}>
                  <Grid container direction="column">
                    <Typography
                      style={{ textAlign: "left" }}
                      className={classes.fieldLabelStyles}
                    >
                      Minutes
                    </Typography>
                    <Select
                      style={{ height: "2em" }}
                      onChange={(value: any) => {
                        setFieldValue("minutes", value.value);
                      }}
                      options={minsSecs_list}
                      value={minsSecs_list.find(
                        (e: any) => e.value === values.minutes
                      )}
                    ></Select>
                  </Grid>
                </Grid>
                <Grid item xs={3}>
                  <Grid container direction="column">
                    <Typography
                      style={{ textAlign: "left" }}
                      className={classes.fieldLabelStyles}
                    >
                      Seconds
                    </Typography>
                    <Select
                      style={{ height: "2em" }}
                      onChange={(value: any) => {
                        setFieldValue("seconds", value.value);
                      }}
                      options={minsSecs_list}
                      value={minsSecs_list.find(
                        (e: any) => e.value === values.seconds
                      )}
                    ></Select>
                  </Grid>
                </Grid>

                <Grid item xs={12}>
                  <Grid
                    container
                    direction="row"
                    spacing={1}
                    justify="flex-end"
                    alignItems="flex-end"
                    className={classes.buttonStyle}
                  >
                    <Grid item xs={6} sm="auto" className={classes.buttonStyle}>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={() => resetForm()}
                        size="medium"
                      >
                        <Typography>Clear</Typography>
                      </Button>
                    </Grid>
                    <Grid item xs={6} sm="auto" className={classes.buttonStyle}>
                      <Button
                        variant="contained"
                        color="primary"
                        // type="submit"
                        onClick={() => handleSubmit()}
                        size="medium"
                      >
                        <Typography>Submit</Typography>
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Paper>
    </div>
  );
};
